<template>
  <div
    :class="[`${$options.name}`, active || innerActive ? `${$options.name}--active` : '']"
    class="tw:p-2 tw:gap-2 tw:flex tw:justify-start tw:items-center tw:caption tw:text-default-500 tw:w-full tw:rounded-sm tw:h-14 tw:min-h-14 tw:overflow-hidden tw:cursor-pointer tw:border tw:border-transparent"
    @click="gtagUniversalSend({ component_id: 'main-menu__settings-button' })"
  >
    <div class="tw:flex tw:justify-center tw:items-center">
      <img
        :alt="trans._menu.header.workspace.avatar"
        :src="logoImage"
        class="tw:border tw:border-default-200 tw:rounded-full tw:w-10 tw:min-w-10 tw:h-10 tw:object-contain tw:bg-default-100"
      />
    </div>
    <div class="tw:flex tw:gap-1 tw:flex-col tw:flex-1 tw:w-0">
      <p class="tw:body-2 tw:truncate">{{ userName }}</p>
      <p class="tw:caption tw:!text-default-700 tw:truncate">
        {{ userEmail }}
      </p>
    </div>

    <div class="tw:flex tw:justify-center tw:items-center tw:!text-default-700 tw:text-xs">
      <font-awesome-icon icon="fa-light fa-angles-up-down" />
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from "vue";
import { gtagUniversalSend } from "vue-app/plugins/edroneGtag";
import { useRoute } from "vue-router";

export default defineComponent({
  name: "MainMenuSettingsButton",
  props: {
    active: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const route = useRoute();
    const user = window.EDRONE_CONTEXT.user;

    const userAvatar = computed(() => {
      return user.avatar
        ? user.avatar.includes("https")
          ? user.avatar
          : "https://dgk28ckagqims.cloudfront.net/avatars/" + user.avatar
        : "https://d3vhsxl1pwzf0p.cloudfront.net/avatar/user.svg";
    });

    const userName = computed(() => {
      return user.isSupport ? user.companyUrl : user.firstName + " " + user.lastName;
    });

    const userEmail = computed(() => {
      return user.isSupport
        ? `${window._trans._menu.header.workspace.workspaceId} : ${window.EDRONE_CONTEXT.trackerId}`
        : user.email;
    });

    const brandingLogo = window.EDRONE_CONTEXT.tracker?.trackerBranding?.logoUrl;
    const logoImage = computed(() => {
      return user.isSupport
        ? brandingLogo || "https://d3vhsxl1pwzf0p.cloudfront.net/avatar/store.svg"
        : userAvatar.value;
    });

    const innerActive = computed(() => {
      return (
        route.path.includes("/app/account") ||
        route.path.includes("/app/settings") ||
        route.path.includes("/app/integrations") ||
        route.path.includes("/app/products")
      );
    });

    return {
      user,
      logoImage,
      userName,
      userEmail,
      innerActive,
      gtagUniversalSend,
    };
  },
});
</script>

<style lang="scss" scoped>
.MainMenuSettingsButton {
  &--active {
    border-color: rgba(163, 163, 0, 0.32);
    background: rgba(224, 224, 0, 0.24);
  }

  &:hover:not(&--active) {
    background-color: rgba(0, 0, 0, 0.08) !important;
  }
}
</style>
